import { LeaderboardTeam } from "@/src/types/JamLeaderboard";
import { Box } from "@amzn/awsui-components-react";
import { memo } from "react";

const WinnerTeamInfo: React.FC<{ team: LeaderboardTeam; index: number }> = memo(({ team, index }) => {
  if (!team) {
    return <div>&nbsp;</div>;
  }

  const cls = ['first', 'second', 'third'][index];

  return (
    <div>
      <div className={`winner-position ${cls}`}>{team.rank}</div>
      <Box fontWeight="bold" color="text-status-info">
        {team.teamDisplayName}
      </Box>
      <Box fontWeight="bold">{team.score} pts</Box>
    </div>
  );
});

export default WinnerTeamInfo;